/* 🤖 this file was generated by svg-to-ts */
export const prizmIconsDiscreteSet: {
  name: 'discrete-set';
  data: string;
} = {
  name: 'discrete-set',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" clip-rule="evenodd" d="M4 2a2 2 0 0 0-2 2v2a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4Zm0 2h5v2H4V4Zm0 6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2H4Zm0 2h5v8H4v-8Zm9-8a2 2 0 0 1 2-2h5a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2h-5a2 2 0 0 1-2-2V4Zm7 0h-5v6h5V4Zm-5 10a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2h-5Zm0 2h5v4h-5v-4Z" fill="currentColor"/></svg>`,
};
